import React from "react";
import { arc } from "d3";

export const GaugeBackgroundArc = () => {
    const backgroundArc = arc()
        .innerRadius(0.85)
        .outerRadius(1)
        .startAngle(-Math.PI / 2)
        .endAngle(Math.PI / 2);

    return <path d={backgroundArc(null)} fill="#dbdbe7" />;
};
